module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-4-fc5316891cc2fa028d0814e42ab543fd.jpg";